import { Button } from '@/components/ui/button'
import { Surface } from '@/components/ui/surface'

/** The B.6 text, verbatim. */
export function FirstUseNotice({ onUnderstood }: { onUnderstood: () => void }) {
  return (
    <Surface variant="page" padding="md" className="space-y-4">
      <h2 className="text-lg font-semibold">Zo werkt inspreken</h2>
      <ul className="list-disc space-y-2 pl-5 text-base">
        <li>
          Je telefoon of browser zet je spraak om in tekst. Bij Chrome gebeurt dat via Google, op
          een iPhone via Apple. VONK ontvangt geen geluid, alleen de tekst.
        </li>
        <li>
          Sparky (Claude van Anthropic) maakt van die tekst voorstellen: een verslag, taken en
          afspraakwijzigingen. Er wordt niets vastgelegd voordat jij het bevestigt.
        </li>
        <li>
          Spreek in ná het gesprek. Neem het gesprek zelf niet op, en noem geen gevoelige
          gegevens zoals gezondheid.
        </li>
        <li>
          Je ingesproken tekst wordt na 30 dagen gewist. Wat je vastlegt, blijft in het CRM.
        </li>
      </ul>
      <Button className="w-full md:w-auto" onClick={onUnderstood}>
        Begrepen
      </Button>
    </Surface>
  )
}
